import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
// Hooks
import useToggle from 'hooks/useToggle';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectCurrentUser } from 'store/currentUser/currentUserSelectors';
import AccountFeatures from 'types/AccountFeatures';
// Components
import { Button } from 'components/Buttons';
// 
import QuizFormDialog from './QuizFormDialog';
import QuizAgentDialog from 'dialogs/QuizAgentDialog';

const QuizzesCreate:FC = () => {
  const { t } = useTranslation();

  const currentUser = useAppSelector(selectCurrentUser);

  const { open, toggle } = useToggle();
  const { open:agentDialogOpen, toggle:toggleAgentDialog } = useToggle();

  return (
    <Fragment>
      <div className="flex items-center gap-2">
        <Button
          onClick={toggle}
          variant="contained"
        >{t('pages.quizzes.createButton')}</Button>
        {currentUser?.account?.features?.includes(AccountFeatures.QuizAgent) ? (
          <Button
            onClick={toggleAgentDialog}
            variant="contained"
          >{t('pages.quizzes.createWithQuizAgentButton')}</Button>
        ) : null}
      </div>
      {open ? (
        <QuizFormDialog
          open={open}
          onClose={toggle}
        />
      ) : null}
      {agentDialogOpen ? (
        <QuizAgentDialog
          open={agentDialogOpen}
          onClose={toggleAgentDialog}
        />
      ) : null}
    </Fragment>
  )
}

export default QuizzesCreate;
